import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { InvoiceFilter } from "../../../data/accounting/accountingOrder/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const AccountingOrderFilterChips: React.FunctionComponent<AccountingOrderFilterChipsProps> = ({
  filter,
  removefilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);

  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("dateto")}
          />
        </Grid>
      )}
    </Grid>
  );
};

interface AccountingOrderFilterChipsProps {
  filter: InvoiceFilter;
  removefilter: (type: keyof InvoiceFilter) => void;
}
